import { STRINGS } from '@/strings/strings';

export const WORLDS = {
  AA: {
    slug: 'aa',
    shortName: 'AA',
    name: 'Abenteuer Alltag',
    emoji: '✨',
    colorVar: '--color-world-aa',
    tagline: STRINGS.worlds.aa.tagline,
  },
  SB: {
    slug: 'sb',
    shortName: 'SB',
    name: 'Schlauberger',
    emoji: '🦊',
    colorVar: '--color-world-sb',
    tagline: STRINGS.worlds.sb.tagline,
  },
  KP: {
    slug: 'kp',
    shortName: 'KP',
    name: 'Kuschelpatrouille',
    emoji: '🌙',
    colorVar: '--color-world-kp',
    tagline: STRINGS.worlds.kp.tagline,
  },
} as const;

export type WorldSlug = (typeof WORLDS)[keyof typeof WORLDS]['slug'];
